import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './assets/index.scss';
import { Button, Card, Divider, Icon, Spin } from 'antd';
import { Redirect } from 'react-router-dom';
import { inject } from 'alfa';

import UserRepo from '../../repository/user';
import Security from '../../helpers/security';

class LoginIndex extends Component { // eslint-disable-line fp/no-class
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      loading: true,
      urlInfo: null,
    };
  }

  componentDidMount() {
    this.loadUser();
  }

  getAuthURL = async () => {
    try {
      const { data } = await UserRepo.authURL();
      Security.registerAuthseed(data.seed);
      this.setState({
        urlInfo: data,
      });
    } catch (error) {
      console.error('ERROR: LoginIndex: UserRepo.authURL()', error); // eslint-disable-line no-console
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  loadUser = () => {
    const { user } = this.props;
    if (!user.requiresLogin()) {
      this.setState({
        redirect: true,
      });
    } else {
      this.getAuthURL();
    }
  }

  renderLoading = () => <Spin />;

  renderForm() {
    return (
      <div className="login-block">
        <Card className="block-inner" bordered={false}>
          <Card.Meta title="Welcome to Lana B2B" description="To get started, you need to login with your user account." />
          <Divider />
          <Button type="primary" block onClick={() => (window.location = this.state.urlInfo.url)}> {/* eslint-disable-line no-return-assign */}
            <Icon type="google" /> Login with Google
          </Button>
        </Card>
      </div>
    );
  }

  render() {
    const { location: { state: locationSatate } } = this.props;
    const { redirect, loading } = this.state;
    if (redirect) {
      const { from } = locationSatate || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }

    if (loading) {
      return this.renderLoading();
    }

    return this.renderForm();
  }
}

LoginIndex.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      from: PropTypes.shape({
        pathname: PropTypes.string,
      }),
    }),
  }),
  user: PropTypes.shape({
    requiresLogin: PropTypes.func,
  }),
};

export default inject(LoginIndex, ['user']);
